<template>
    <div class="shop-filter-field" :class="{'shop-filter-field--nested': compact}">
        <el-select
            :placeholder="formField.title"
            :value="value"
            @change="value => handleOnChange(value)"
            clearable
            size="medium"
            class="shop-filter-el-select"
        >
            <el-option
                v-for="option in formField.options"
                :key="option.id"
                :label="option.title"
                :value="option.id"
            />
        </el-select>

        <div v-if="visibleChildFields.length" class="shop-filter-nested">
            <FormFieldFilter
                v-for="childFormField in visibleChildFields"
                :key="childFormField.id"
                :formField="childFormField"
                :onChangeHandler="onChangeHandler"
                compact
            />
        </div>
    </div>
</template>
<script>
export default {
    name: 'DropDown',
    components: {
        FormFieldFilter: () => import('./FormFieldFilter.vue'),
    },
    props: {
        formField: {
            required: true,
            type: Object,
        },
        onChangeHandler: {
            required: true,
            type: Function,
        },
        compact: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            value: '',
            selectedOptionId: null,
        }
    },

    computed: {
        visibleChildFields() {
            const optionId = this.selectedOptionId;

            if (!optionId) {
                return [];
            }

            return (this.formField.form_fields || []).filter(
                childFormField => +childFormField.form_field_option_id === +optionId
            );
        },
    },

    methods: {
        handleOnChange(value) {
            if (!value) {
                this.value = '';
                this.selectedOptionId = null;
                this.onChangeHandler(`additional_data[${this.formField.slug}]`, null, false);
                this.onChangeHandler(`additional_data[${this.formField.slug}_option_id]`, null, true);
                return;
            }

            const option = this.formField.options.find(options => options.id === +value);
            this.value = option.title;
            this.selectedOptionId = option.id;

            this.onChangeHandler(`additional_data[${this.formField.slug}]`, this.value, false)
            this.onChangeHandler(`additional_data[${this.formField.slug}_option_id]`, option.id, true)
        }
    },

    mounted() {
        if (this.selectedFilters[`additional_data[${this.formField.slug}]`] ?? false) {
            this.value = decodeURIComponent(this.selectedFilters[`additional_data[${this.formField.slug}]`]).replaceAll('+', ' ');
        }

        const optionId = this.selectedFilters[`additional_data[${this.formField.slug}_option_id]`];

        if (optionId) {
            this.selectedOptionId = +optionId;
        }
    }
}
</script>
